module.exports = __webpack_public_path__ + "img/clouds-white.268a8762.png";